import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './navigation/AuthProvider';
import { RootAuthProvider } from './navigation/RootAuthProvider';
import { RecoilRoot } from 'recoil';
import CustomToast from './components/modal/CustomToast';
import RecoilNexus from 'recoil-nexus';
import toast, { Toaster } from 'react-hot-toast';

if (process.env.REACT_APP_ENV != undefined && process.env.REACT_APP_ENV === 'PRD') {
  console.log = () => null;
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <AuthProvider ref={RootAuthProvider}>
      <RecoilRoot>
        <RecoilNexus />
        <BrowserRouter
          basename={process.env.REACT_APP_BASE_URL ? process.env.REACT_APP_BASE_URL : ''}>
          <App />
          <link rel="stylesheet" href="https://unpkg.com/react-quill@1.3.3/dist/quill.snow.css" />
          <Toaster />
          <CustomToast message="" type="success" />
        </BrowserRouter>
      </RecoilRoot>
    </AuthProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
